import React from 'react';
import DataTable from 'components/data-table';
import {RowItemCoQuanTiepDan} from 'modules/reception/datatable/add';
import {header} from "constants/table";
import { connect } from 'react-redux';
import {validatable} from 'components/utils';

class ThongTinCoQuanTiepDan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dsCoQuanToChucTiepDan: []
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.soTiepCongDan != this.props.soTiepCongDan) {
      let data = nextProps.soTiepCongDan;
      data.coQuanToChucTiepDanSTCD.map((item, i) => {
        this.state.dsCoQuanToChucTiepDan[i] = {
          coQuanToChucTiepDanId: item.coQuanToChucTiepDanId,
          ten: item.coQuanDonViInfo.coQuanQuanLyId,
          chucVu: item.chucVu,
          nguoiDaiDien: item.nguoiDaiDien
        };       
      });
 
      this.setState({...this.state});      
      this.props.onInit(this.state);
    }
  }

  addDsCoQuanCungTiepDan() {
    let arrLength = this.state.dsCoQuanToChucTiepDan.length;
    if (arrLength == 0 || (arrLength > 0 && this.state.dsCoQuanToChucTiepDan[arrLength - 1].ten != '')) {
      this.state.dsCoQuanToChucTiepDan[this.state.dsCoQuanToChucTiepDan.length] = {
        coQuanToChucTiepDanId: 0,
        ten: null,
        nguoiDaiDien: '',
        chucVu: ''
      };
      this.setState({
        ...this.state
      });
    }
  }

  onChangeTable(data, index) {
    this.state.dsCoQuanToChucTiepDan[index] = data;
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  onRemoveItem(index) {
    this.state.dsCoQuanToChucTiepDan.splice(index, 1);
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  render() {
    return (
      <div className="box-items pb15">
        <div className="box-forward">
          <div className="container-box">
            <div className="group-box">
              <div className="title">
                <div className="rows">
                    <div className="col-12">
                      <h3>Danh sách cơ quan, các đơn vị cùng tham gia tiếp công dân</h3>
                    </div>
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <div className="col-12 row-center">
                    <DataTable
                      header = {header.receptionPeriodical.add}
                      dataList = {this.state.dsCoQuanToChucTiepDan}
                      hidePagination={true}
                      hideExport={true}   
                      showAddMore={true}
                      addMore={this.addDsCoQuanCungTiepDan.bind(this)}
                      tableLoading={false}>
                      <RowItemCoQuanTiepDan onChange={this.onChangeTable.bind(this)} 
                        bindValidator={this}
                        onRemove={this.onRemoveItem.bind(this)}/>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function bindStateToProps(state) {
  return {
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan
  };
}

export default connect(bindStateToProps)(validatable(ThongTinCoQuanTiepDan));


// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/ThongTinCoQuanTiepDan.jsx